import { FormLabel, Grid, TextField } from "@mui/material";


export const ViewAndEditEntity = ({
  
    handleInputChange,
    index,
    row,
    viewMode,
    validationStatus,
}) => {
    //inline style
    const InlineStyle = {
        EntityDivison: {
            width: "230px", height: "32", padding: "0px"
        },
    }
    return (
      <form>
        <Grid container justifyContent={"space-between"}>
          <Grid
            item
            xs={6}
            md={4}
            lg={3}
            display={"flex"}
            flexDirection={"column"}
            gap={"5px"}
            mt={"20px"}
          >
            <FormLabel>Entity Division</FormLabel>
            <TextField
              value={row.entity_divisions}
              onChange={(e) =>
                handleInputChange(index, "entity_divisions", e.target.value)
              }
              sx={InlineStyle.EntityDivison}
              size="small"
              placeholder="Enter Details Here"
              disabled={viewMode}
            />
            <br />
            {validationStatus[index]?.entity_divisions && (
              <span style={{ color: "red" }}>
                {validationStatus[index]?.entity_divisions}
              </span>
            )}
          </Grid>
      
          <Grid
           item
            xs={3}
            md={3}
            lg={3}
            display={"flex"}
            flexDirection={"column"}
            gap={"5px"}
            mt={"20px"}
          >
            <FormLabel>Entity Name</FormLabel>
            <TextField
              value={row.entity_name}
              onChange={(e) =>
                handleInputChange(index, "entity_name", e.target.value)
              }
              sx={InlineStyle.EntityDivison}
              size="small"
              placeholder="Enter Details Here"
              disabled={viewMode}
            />
            <br />
            {validationStatus[index]?.entity_name && (
              <span style={{ color: "red" }}>
                {validationStatus[index]?.entity_name}
              </span>
            )}
          </Grid>
        </Grid>
      </form>
    );
}